<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <el-form :model="query" ref="queryForm" :inline="true">
          <el-form-item label="名称：" prop="name">
            <el-input v-model="query.name" placeholder="请输入名称" size="small" clearable />
          </el-form-item>
          <el-form-item label="是否启用：">
            <el-select v-model="query.isEnable" placeholder="请选择" clearable size="small">
              <el-option label="是" :value="true"></el-option>
              <el-option label="否" :value="false"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="fr">
            <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
            <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card class="box-card mt10">
      <div class="btn-right-side mb10">
        <div class="btn-box">
          <el-button type="primary" size="mini" @click="handleCreate" icon="el-icon-plus">添加</el-button>
        </div>
      </div>
      <el-table v-loading="listLoading" :data="list" border>
        <el-table-column type="index" label="序号" width="60" align="center" />
        <el-table-column label="名称" prop="name" align="center" />
        <el-table-column label="是否启用" prop="isEnable" align="center">
          <template slot-scope="{row}">
            <el-tag :type="row.isEnable ? 'success' : 'info'">
              {{ row.isEnable ? '是' : '否' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="200" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" @click="handleUpdate(scope)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
    </el-card>
    <!-- 新建/编辑表单 -->
    <disease-add ref="diseaseAdd" @created="doQueryList" :rowItem="rowItem" />
  </div>
</template>

<script>
import diseaseAdd from './add'
import diseaseApi from '@/api/sys/disease'
import Pagination from '@/components/Pagination'

export default {
  components: {
    diseaseAdd,
    Pagination
  },
  data() {
    return {
      list: [],
      total: 0,
      listLoading: true,
      rowItem: null,
      query: {
        pageNo: 1,
        pageSize: 10,
        name: '',
        isEnable: undefined
      }
    }
  },
  created() {
    this.doQueryList()
  },
  methods: {
    /**
     * 执行列表查询
     */
    doQueryList({ pageNo, pageSize } = {}) {
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }
      this.listLoading = true
      const params = { ...this.query }
      // 处理 isEnable 参数，如果为 undefined 则不传
      if (params.isEnable === undefined || params.isEnable === '') {
        delete params.isEnable
      }
      return diseaseApi.fetchList(params)
        .then(({ data }) => {
          this.list = data.records || data.list || []
          this.total = data.total || 0
        })
        .catch((error) => {
          console.error('获取列表失败:', error)
          this.list = []
          this.total = 0
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    /**
     * 触发搜索操作
     */
    handleQuery() {
      this.doQueryList({ pageNo: 1 })
    },
    /**
     * 重置搜索
     */
    handleFilter() {
      this.query = {
        pageNo: 1,
        pageSize: 10,
        name: '',
        isEnable: undefined
      }
      this.doQueryList()
    },
    /**
     * 打开新建表单
     */
    handleCreate() {
      this.$refs.diseaseAdd.handleCreate()
    },
    /**
     * 打开编辑表单
     */
    handleUpdate(scope) {
      this.rowItem = scope.row
      this.$refs.diseaseAdd.handleUpdate(scope.row)
    }
  }
}
</script>

<style scoped>
.btn-right-side {
  display: flex;
  justify-content: flex-end;
}
</style>

